import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ARTICLES } from "../../data/articles";
import { Reveal } from "../Reveal";

export const InsightsPreview = () => (
  <section className="border-t border-white/5" data-testid="insights-section">
    <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
      <Reveal>
        <p className="eyebrow">Insights</p>
        <h2 className="mt-6 max-w-4xl font-display text-4xl font-black leading-[1.02] tracking-tighter md:text-6xl lg:text-7xl">
          IT tips, backed by real numbers.
        </h2>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#C9D2DE] md:text-lg">
          Research from IBM, Verizon, Sophos and the FBI — translated into what it actually means for a business
          your size.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
        {ARTICLES.map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.08}>
            <Link
              to={`/insights/${a.slug}`}
              data-testid={`article-card-${a.slug}`}
              className="group glass flex h-full flex-col justify-between p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand/40"
            >
              <div>
                <div className="flex items-center gap-3">
                  <span className="font-display text-xs font-bold uppercase tracking-[0.25em] text-brand">{a.tag}</span>
                  <span className="text-xs text-zinc-600">{a.readTime}</span>
                </div>
                <h3 className="mt-4 font-display text-xl font-bold leading-snug tracking-tight text-white">{a.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#C9D2DE]">{a.excerpt}</p>
              </div>
              <span className="mt-8 inline-flex items-center gap-2 font-display text-xs font-bold uppercase tracking-[0.2em] text-[#A8B4C2] transition-colors duration-300 group-hover:text-brand">
                Read <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
